<template>
  <b-form-group :label="field.label" :label-for="`${field.key}Input`" :description="field.description">
    <b-spinner v-if="loading" :style="{ height: '32px', width: '32px' }" type="grow" variant="primary"/>
    <div class="d-flex flex-row" v-else>
      <a class="mr-2" :href="value.fileLocation" target="_blank" v-if="showPreview && value && value.fileLocation">
        <b-img v-if="type === 'IMAGE'" :src="value.fileLocation | cdn('resize', 40, 40)" :alt="value.fileName || null"
          height="40px" width="40px"/>
      </a>
      <div class="d-flex flex-column flex-fill">
        <b-form-file :id="id || `${field.key}Input`" :placeholder="value && value.fileName ? value.fileName : placeholder"
          :accept="accept" :class="{ 'is-invalid': err }" :disabled="disabled" :state="state" @change="e => receivedFile(e)"/>
        <div v-if="err" class="invalid-feedback">
          <template v-if="err.message">{{ err.message }}</template>
          <template v-else>{{ `${err}` }}</template>
        </div>
        <a v-else-if="value && value.fileLocation" class="text-danger text-decoration-none" @click.prevent="() => $emit('input', null)" href="#">
          &times; Clear
        </a>
      </div>
    </div>
  </b-form-group>
</template>

<script>
import assetUploadMixin from '@/mixins/assetUpload';
import { createSha1File } from '@/lib/hashing';

export default {
  props: {
    field: Object,
    accept: String,
    id: String,
    disabled: Boolean,
    placeholder: String,
    showPreview: {
      type: Boolean,
      default: () => false,
    },
    state: {
      type: Boolean,
      default: () => null,
    },
    value: Object,
  },
  mixins: [ assetUploadMixin ],
  data: () => ({
    err: null,
    loading: false,
  }),
  computed: {
    type() {
      if (this.field && this.field.type && this.field.type.indexOf('asset-') === 0) {
        return this.field.type.substr('asset-'.length).toUpperCase();
      } else if (this.field && this.field.type && [ 'IMAGE', 'DOCUMENT' ].includes(this.field.type.toUpperCase())) {
        return this.field.type.toUpperCase();
      } else {
        return null;
      }
    },
  },
  methods: {
    async receivedFile(e) {
      const { fileInput } = this.$refs;
      try {
        this.$assert(event.target.files && event.target.files.length, new Error('Expected a file to be selected'));

        const [ file ] = event.target.files;
        this.$assert(file && file.name, new Error('No file was selected'), {
          code: 'FILE_NOT_FOUND',
        });

        this.loading = true;

        this.$log.debug(file);

        const { token, asset: uploading, upload } = await this.createAssetMutation({
          type: this.type,
          fileName: file.name,
          fileMime: file.type,
          fileSize: file.size,
          fileSha1: await createSha1File(file),
        });

        this.$log.debug({ file: file.name, uploading, upload });

        await this.initAssetUpload(upload, file);

        const asset = await this.uploadedAssetMutation(token);
        this.$emit('input', asset);
      } catch (err) {
        this.$log.error(err);
        this.err = err;
      } finally {
        if (fileInput) {
          fileInput.value = null;
        }
        this.loading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/AssetBlock.vue